var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 8.33333H15.6367C15.9207 8.33334 16.2001 8.40595 16.4482 8.54427C16.6963 8.68259 16.9049 8.88202 17.0543 9.12364C17.2036 9.36525 17.2888 9.64104 17.3016 9.9248C17.3144 10.2086 17.2545 10.4909 17.1275 10.745L14.2108 16.5783C14.0724 16.8554 13.8595 17.0884 13.596 17.2512C13.3325 17.414 13.0289 17.5001 12.7192 17.5H9.37167C9.23583 17.5 9.1 17.4833 8.9675 17.45L5.83333 16.6667M11.6667 8.33333V4.16667C11.6667 3.72464 11.4911 3.30072 11.1785 2.98816C10.866 2.67559 10.442 2.5 10 2.5H9.92083C9.50417 2.5 9.16667 2.8375 9.16667 3.25417C9.16667 3.84917 8.99083 4.43083 8.66 4.92583L5.83333 9.16667V16.6667M11.6667 8.33333H10M5.83333 16.6667H4.16667C3.72464 16.6667 3.30072 16.4911 2.98816 16.1785C2.67559 15.866 2.5 15.442 2.5 15V10C2.5 9.55797 2.67559 9.13405 2.98816 8.82149C3.30072 8.50893 3.72464 8.33333 4.16667 8.33333H6.25",
    stroke: "#710D10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/thumbs-up-icon.07f4897413a934ca0cc20c2d49fd18fc.svg";
export { ForwardRef as ReactComponent };